window.actualizarTablaInyeccionPeriodo = null;

if (window.location.pathname === "/inyeccion/periodo") {
    
    // Configuración de las opciones de la solicitud
    const requestOptions = {
        method: "GET",
        credentials: "include", // Incluye las cookies automáticamente
        headers: {
            "Content-Type": "application/json", // Si es necesario especificar un tipo de contenido
        },
        redirect: "follow",
    };

    const tableBody = document.querySelector("#tablaInyeccionPeriodo tbody");
    var params = new URLSearchParams(window.location.search);
    var mes = params.get("mes");
    var año = params.get("año");

    function skeletonTabla() {
        let html = '';
        for (let i = 0; i < 5; i++) {
            html += `<tr class="skeletonFila">
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
                <td><span></span></td>
            </tr>`;
        }
        return html;
    }

    window.actualizarTablaInyeccionPeriodo = (mes, año) => {

        tableBody.innerHTML = skeletonTabla();

        const url = `/api/inyeccion/periodo?filtroMes=${mes}&filtroAnio=${año}`;

        function f(numero) {
            if (numero === null || numero === undefined || isNaN(numero)) return 0;
            return Number(numero).toLocaleString('en-US');
        }
        
        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                // Limpiar la tabla antes de llenarla nuevamente
                tableBody.innerHTML = "";
                tableBody.classList.remove('cargado');
                void tableBody.offsetWidth;
                tableBody.classList.add('cargado');
                const data = result.result;
                const textoEstado = (estado) => Number(estado) === 1 ? 'ACTIVO' : 'FINALIZADO';
                const classEstado = (estado) => Number(estado) === 1 ? 'tdVerde' : 'tdGris';
                const classEstadoFila = (estado) => Number(estado) !== 2 ? 'trVerde' : null;
                const fecha = (fechaOriginal) => fechaOriginal.split('-').reverse().join('/');

                if (!data || data.length === 0) {
                    const row = document.createElement("tr");
                    row.classList.add("no-data");
                    row.innerHTML = `
                        <td colspan="13">
                            <div class="cont-no-data">
                                No se encontró información.
                                <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                            </div>
                        </td>
                    `;
                    tableBody.appendChild(row);
                    return;
                }

                data.forEach(item => {
                    // Fila Principal
                    const rowPadre = document.createElement("tr");
                    rowPadre.classList.add("filaPrincipal"); // Clase para el cursor pointer y evento
                    rowPadre.classList.add(item.totalDia.estado); // Clase para el cursor pointer y evento
                    const clase = classEstadoFila(item.totalDia.estado);
                    if (clase) {rowPadre.classList.add(clase);}
                    
                    // Calculamos el % de eficiencia del día para la fila principal
                    const pBueno = item.totalDia.undTotal > 0 ? ((item.totalDia.undBueno / item.totalDia.undTotal) * 100).toFixed(2) : 0;
                    const pMalo = item.totalDia.undTotal > 0 ? ((item.totalDia.undMalo / item.totalDia.undTotal) * 100).toFixed(2) : 0;
                    rowPadre.innerHTML = `
                        <td>${fecha(item.fecha)}</td>
                        <td>${f(item.totalDia.undTotal)}</td>
                        <td>${pBueno}%</td>
                        <td>${pMalo}%</td>
                        <td>${f(item.totalDia.cumplimiento)}%</td>
                        <td>${f(item.totalDia.horasActivas)} h</td>
                        <td>${f(item.totalDia.minMuertos)}'</td>
                    `;

                // 2. FILA DETALLE (Contenedor de tarjetas)
                    const rowHijo = document.createElement("tr");
                    rowHijo.classList.add("filaDetalle"); // Cambia por tu clase de CSS que tiene el display:none

                    let htmlTurnos = '';
                    
                    // Iteramos sobre item.reportes (el Array(1) que viste en tu log)
                    item.reportes.forEach(reporte => {
                        htmlTurnos += `
                            <article class="cardTurno">
                                <header class="cardTurno__header">
                                    <span>${reporte.nombreTurno} | ${fecha(item.fecha)}</span>
                                    <button class="btnVerReporte btnIconAzulTxtBlanco btnModal" data-id="${reporte.idReporteInyeccion}" data-modal="modalProduccionInyeccion">
                                        <img src="/public/build/img/icons/ojo.svg" alt="ver">
                                        <span>Ver reporte</span>
                                    </button>
                                </header>
                                <div class="cardTurno__body">
                                    <div class="item"><span class="label">Und. Prod.</span><span class="value">${f(reporte.undTotal)}</span></div>
                                    <div class="item"><span class="label">Und. Buenas</span><span class="value">${f(reporte.undBueno)}</span></div>
                                    <div class="item"><span class="label">Und. PNC</span><span class="value">${f(reporte.undMalo)}</span></div>
                                    <div class="item"><span class="label">Peso Prod.</span><span class="value">${reporte.pesoTotal} t</span></div>
                                    <div class="item"><span class="label">Peso Bueno</span><span class="value">${f(reporte.pesoBueno)} t</span></div>
                                    <div class="item"><span class="label">Peso PNC</span><span class="value">${f(reporte.pesoMalo)} kg</span></div>
                                    <div class="item"><span class="label">% 1A</span><span class="value">${f(reporte.porcBueno)}%</span></div>
                                    <div class="item"><span class="label">% PNC</span><span class="value">${f(reporte.porcMalo)}%</span></div>
                                    <div class="item"><span class="label">Prom. Und/Hora</span><span class="value">${f(reporte.promUndDia)}</span></div>
                                    <div class="item"><span class="label">Horas Activas</span><span class="value">${f(reporte.totalHorasActivas)} h</span></div>
                                    <div class="item"><span class="label">T. Muerto</span><span class="value">${f(reporte.totalMinutosMuertos)}'</span></div>
                                    <div class="item"><span class="label">Estado</span><span class="value ${classEstado(reporte.estado)}">${textoEstado(reporte.estado)} - ${f(reporte.cumplimiento)}%</span></div>
                                </div>
                            </article>
                        `;
                    });

                    rowHijo.innerHTML = `
                        <td colspan="12">
                            <div class="detalleContenido">
                                <div class="detalleTurnos">
                                    ${htmlTurnos}
                                </div>
                            </div>
                        </td>
                    `;
                    tableBody.appendChild(rowPadre);
                    tableBody.appendChild(rowHijo);
                });
            })
            .catch((error) => {
                if (error.name === 'AbortError') return;
                console.error("Error tabla inyección periodo:", error);
                return;
            });
    };

    window.actualizarTablaInyeccionPeriodo(mes, año);

    setInterval(() => {
        window.actualizarTablaInyeccionPeriodo(mes, año);
    }, 120000);
}